/**
 * Extracts project key from the URL path
 * Pattern matches: /jira/polaris/projects/{projectKey}/...
 * @param location The location object to extract from
 * @returns The project key if found, null otherwise
 */
export const getProjectKeyFromLocation = (location: Location): string | null => {
	// Handle empty or invalid location
	if (!location || !location.pathname) {
		return null;
	}

	// Get the pathname and remove trailing slash if present
	let pathname = location.pathname;
	if (pathname.endsWith('/') && pathname.length > 1) {
		pathname = pathname.slice(0, -1);
	}

	// Simple regex to extract projectKey from polaris ideas URLs
	// Pattern matches: /jira/polaris/projects/{projectKey}/ideas/...
	const regex = /\/jira\/polaris\/projects\/([^/]+)\/ideas/;
	const match = pathname.match(regex);

	// Return projectKey if found, otherwise null
	return match ? match[1] : null;
};

/**
 * Extracts view ID from the URL path
 * Pattern matches: /jira/polaris/projects/{projectKey}/ideas/view/{viewId}
 * @param location The location object to extract from
 * @returns The view ID if found, null otherwise
 */
export const getViewIdFromLocation = (location: Location): string | null => {
	// Handle empty or invalid location
	if (!location || !location.pathname) {
		return null;
	}

	// Get the pathname and remove trailing slash if present
	let pathname = location.pathname;
	if (pathname.endsWith('/') && pathname.length > 1) {
		pathname = pathname.slice(0, -1);
	}

	// Simple regex to extract viewId from polaris ideas view URLs
	// Pattern matches: /jira/polaris/projects/{projectKey}/ideas/view/{viewId}
	const regex = /\/jira\/polaris\/projects\/[^/]+\/ideas\/view\/([^/]+)/;
	const match = pathname.match(regex);

	// Return viewId if found, otherwise null
	return match ? match[1] : null;
};

/**
 * Extracts issue key from location's query parameters
 * Specifically looks for the selectedIssue parameter
 * @param location The location object to extract from
 * @returns The issue key if found, null otherwise
 */
export function getIssueKeyFromLocation(location: Location): string | null {
	if (location.search) {
		const params = new URLSearchParams(location.search);
		return params.get('selectedIssue');
	}
	return null;
}
